import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import { State } from "../../../vendor_core/core/src/states/State";
import { IVendorSpinData } from "../../../vendor_core/src/model/IVendorSpinData";
import BURFeatureModel from "../models/BURFeatureModel";
import BURSpinModel from "../models/BURSpinModel";
import BURReelSymbol from "../view/BURReelSymbol";
import BURReelsModel from "../models/BURReelsModel";

export default class BURFreeSpinStartState extends State {
    public async enter() {
        super.enter();
        const fsIndex = BURSpinModel.current_free_spin_index;

        // Update the free spin data
        const fsData = {
            data: {
                gameData: BURFeatureModel.free_spins_data!.freeSpins[
                    fsIndex
                ] as IVendorSpinData
            }
        };

        SpinModel.update(fsData);

        // Get the sticky wilds positions, transform the symbols to wilds and lock them on the reels
        if (BURFeatureModel.feature_has_sticky_wilds) {
            await Promise.all(
                fsData.data.gameData.view.map(async (reel, reelIndex) => {
                    await Promise.all(
                        reel.map(async (symbolId, symbolIndex) => {
                            if (symbolId === BURReelsModel.wild_id) {
                                const sbl = BURReelsModel.reels.reels[reelIndex]
                                    .symbols[symbolIndex] as BURReelSymbol;
                                sbl.setIsLocked(true);
                                sbl.setIsMystery(false);
                                await BURReelsModel.reels.transformSymbolToWild(
                                    { x: reelIndex, y: symbolIndex }
                                );
                            }
                        })
                    );
                })
            );
        }

        this.exit();
    }
}
